import { dateFormat, dateTimeFormat } from 'constants/dateTimeFormat'
import { lightFormat } from 'date-fns'

export const formatDate = (date) => date && lightFormat(date, dateFormat)
export const formatDateTime = (date) => date && lightFormat(date, dateTimeFormat)
